module.exports = __webpack_public_path__ + "static/media/tree.a61c0af9.svg";